import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';
import FileServiceModel from '@/models/FileServiceModel';
import TimestampAble    from '@widesk-core/models/traits/TimestampAble';
import Blamable         from '@/models/traits/Blamable';

@model.cacheDuration()
@model.urnResource('stonecode_file_type')
@doc.path('/stonecode_file_types/{?id}')

export default class StonecodeFileTypeModel extends Blamable(TimestampAble(FileServiceModel)) {
	private declare _tsFilters: {
		'deprecated': '0' | '1';
		'policy': id;
		'policy.reference': File_PolicyReference;
		'reference': File_StonecodeFileTypeReference;
		'service': id;
		'service.serviceUrn': Urn;
		'system': '0' | '1';
		'urnMask': id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'label': string;
		'updatedAt': string;
	};

	@doc.boolean declare defaultLock: boolean;
	@doc.boolean declare deprecated: boolean;
	@doc.string declare label: string;
	@doc.number declare maxPerSource: number;
	@doc.number declare maxSize: number;
	@doc.string declare reference: File_StonecodeFileTypeReference;
	@doc.boolean declare system: boolean;
	@doc.string declare urnMask: string;
}